export const strings = {
    portfolioPerformance: 'Portfolio performance',
};
